
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[areaId]/subscriptions",
      function () {
        return require("private-next-pages/[areaId]/subscriptions/index.tsx");
      }
    ]);
  